import { Box, Button, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useAuth } from "../../auth/AuthContext";

export default function NoAccessPage() {
  const navigate = useNavigate();
  const { permissions, user } = useAuth();
  const roleName = permissions?.roleName || "no role";

  return (
    <Box sx={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      bgcolor: "background.default", p: 3,
    }}>
      <Paper sx={{ p: 5, maxWidth: 480, textAlign: "center", borderRadius: 3 }}>
        <Box sx={{
          width: 64, height: 64, borderRadius: "50%", bgcolor: "#FEE2E2",
          display: "flex", alignItems: "center", justifyContent: "center",
          mx: "auto", mb: 2,
        }}>
          <LockOutlinedIcon sx={{ fontSize: 32, color: "#DC2626" }} />
        </Box>
        <Typography sx={{ fontSize: 20, fontWeight: 800, mb: 1 }}>
          You don't have access to this page
        </Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary", mb: 1 }}>
          Your current role (<b>{roleName}</b>) doesn't include it.
        </Typography>
        <Typography sx={{ fontSize: 12, color: "text.secondary", mb: 3 }}>
          Ask a super-admin to update your role in the Admin Panel.
        </Typography>
        <Typography sx={{ fontSize: 11, color: "text.disabled", mb: 3 }}>
          Signed in as {user?.email}
        </Typography>
        <Button variant="contained" onClick={() => navigate("/")}>
          Back to Home
        </Button>
      </Paper>
    </Box>
  );
}
